// extracted by mini-css-extract-plugin
export default {"snackbar":"explain-modal_snackbar__a34qu","close":"explain-modal_close__cIKJN"};